export const it = {
    "TRIGGER_LISTEN": "Ascolta attivazione",
    "ASSIST_EMPTY_MSG": "L'AI dell'agente sta attivamente ascoltando ed è pronta ad assistere automaticamente quando attivata.",
    "MYBOT_TRIGGET_LISTEN": "Nessun compito di My Bot attualmente disponibile",
    "MYBOT_EMTPY_MSG": "Per avviare un compito su My Bot, vai alla scheda di ricerca e seleziona l'opzione \"Esegui con input dell'agente\" per il compito desiderato.",
    "PROACTIVE_MODE": "Modalità proattiva",
    "SETTINGS": "Impostazioni",
    "HELP_AND_SUPPORT": "Aiuto e supporto",
    "HELP": "Aiuto",
    "LANGUAGE": "Lingua",
    "THEME": "Tema",
    "AUTOMATIC": "Automatico",
    "DARK": "Scuro",
    "LIGHT": "Chiaro",
    "THEME_DESC": "Questo utilizzerà la modalità predefinita del tuo sistema.",
    "DOCUMENTATION": "Documentazione",
    "DOC_DESC": "Leggi i nostri articoli di documentazione completi.",
    "FAQ_U": "FAQ",
    "FAQ_DESC": "Visualizza le domande frequenti su Agent AI.",
    "KORE_ACADEMY": "Kore Academy",
    "KORE_ACA_DESC": "Scopri di più su Agent AI frequentando i corsi dell'accademia.",
    "SEARCH": "Cerca",
    "MY_BOT": "Il Mio Bot",
    "ASSIST": "Assistenza",
    "TRANSCRIPT": "Trascrizione",
    "HISTORY": "Cronologia",
    "STARTOVER": "Ricomincia",
    "RESTART_INPUTS": "Riavvia con input raccolti",
    "ASKCUSTOMER": "Chiedi al cliente",
    "TELLCUSTOMER": "Dì al cliente",
    "TAP_SEARCH":"Tocca per cercare",
    "WELCOME_MSG": "Messaggio di benvenuto",
    "SEND": "Invia",
    "SENT": "Inviato",
    "AWAITING": "In attesa di risposta | Tocca per continuare",
    "OVERRIDE": "Tocca per continuare",
    "ACCEPT_RESPONSE": "Accetta risposta",
    "AGENT_ENTERED": "Agente entrato",
    "EXPECTED_FORMAT": "Formato previsto",
    "INPUT_VALUES": "Valori di input",
    "RESTART": "Riavvia",
    "START_OVER": "Ricomincia",
    "RESTART_CAPTURE": "Riavvia con input raccolti",
    "CANCEL": "Annulla",
    "INTERRUPT_DIALOG": "COMPITO DI DIALOGO INTERROTTO",
    "RUN": "ESEGUI",
    "RUN_AGENT": "Esegui con input dell'agente",
    "STEP": "Passo",
    "DIALOG_TASK": "Compito di dialogo",
    "FAQ": "FAQ",
    "SNIPPET": "Risposte",
    "ARTICLE": "Articoli",
    "FILE": "File",
    "SUGGESTED": "Suggerito",
    "ALL_DIALOG": "Tutti i compiti di dialogo",
    "DIALOG_TEXT": "Dialogo",
    "INTENT_IDENTIFIED": "Intento identificato",
    "NOT_WHAT_LOOKING": "Suggerimento sbagliato?",
    "BOT": "Bot",
    "CUSTOMER": "Cliente",
    "YOU": "Tu",
    "TERMINATE_CONV": "Termina compito di dialogo",
    "TERMINATE_CONV_DESC": "Sei sicuro di voler terminare il compito di dialogo? L'AI dell'agente non può più fare suggerimenti.",
    "YES_TERMINATE": "Sì, termina",
    "NO_CANCEL": "No, annulla",
    "OVERRIDE_CONTINUE": "Continua in modalità override",
    "SUMMARY_TEXT": "Riepilogo",
    "SUBMIT": "Invia",
    "INTERRUPT_OCCURED": "Interruzione avvenuta",
    "IDENTIFIED_INTENT": "Intento identificato",
    "INTERRUPT_DESC": "L'esecuzione terminerebbe il tuo attuale compito di dialogo.",
    "ACCEPT_RUN": "Accetta ed esegui",
    "RUN_LATER": "Esegui più tardi",
    "KNOW_MORE": "Scopri di più",
    "MORE_TEXT": "Di più",
    "LESS_TEXT": "Meno",
    "VIEW_MORE": "Mostra di più",
    "VIEW_LESS": "Mostra di meno",
    "SHOW_MORE_FAQ": "Mostra più FAQ",
    "SHOW_LESS_FAQ": "Mostra meno FAQ",
    "SHOW_MORE_ARTICLE": "Mostra più articoli",
    "SHOW_LESS_ARTICLE": "Mostra meno articoli",
    "SHOW_MORE_SNIPPET": "Mostra più risposte",
    "SHOW_LESS_SNIPPET": "Mostra meno risposte",
    "SHOW_MORE_FILES": "Mostra più file",
    "SHOW_LESS_FILES": "Mostra meno file",
    "VIEW_ALL_DIALOG": "Mostra tutti i dialoghi",
    "VIEW_FEW_DIALOG": "Mostra alcuni dialoghi",
    "HELP_FULL": "Utile?",
    "THANKYOU": "Grazie!",
    "EXPAND_MORE": "Mostra di più \/ Di più",
    "CLOSE_TEXT": "Chiudi",
    "STARTED": "Iniziato",
    "ENDED": "Terminato",
    "VIEW_FULL_ARTICLE": "Visualizza articolo completo",
    "VIEW_FULL_FILE": "Visualizza file completo",
    "COPIED": "Copiato",
    "SENTI_ANALY": "Analisi del sentimento",
    "WRONG_SUGGESTION": "Suggerimento errato",
    "INCORRECT_INTENT": "Intento sbagliato",
    "ACCIDENTAL_CLICK": "Clic accidentale",
    "TIME_TAKING": "Richiede tempo",
    "AUTOSCROLL_ASSIST":"Assistenza scorrimento automatico",
    "OTHER": "Altro",
    "PLAYBOOK_EMPTY_MSG": "Seleziona un Playbook",
    "PLAYBOOK_EMPTY_DESC": "Agent AI non può caricare il Playbook poiché tutti i Playbook disponibili sono dinamici. Clicca su \"Seleziona Playbook\" per accedere al Playbook.",
    "STAGE": "Fase",
    "PROCEED_TO_CLOSE": "Procedi alla chiusura",
    "RECOMENDED_PLAYBOOK": "PLAYBOOK CONSIGLIATO",
    "AUTO_SCROLL_TOOLTIP":"Controlla lo scorrimento automatico della scheda Assistenza, del mio bot e dei contenuti della scheda Trascrizione",
    "PRIMARY_SCRIPTS": "SCRIPT PRIMARI",
    "DYNAMIC_SCRIPTS": "SCRIPT DINAMICI",
    "ASK_A_QUESTION":"Fai una domanda",
    "FILE_NAME":"Nome del file",
    "RESUME": "Riprendi",
    "ENABLE_CLOSE": "Clicca su \"Procedi alla chiusura\" per abilitare la fase di chiusura.",
    "LIST_VIEW": "Vista elenco",
    "TERMINATE": "Termina",
    "MINIMIZE": "Minimizza",
    "MAXIMIZE": "Massimizza",
    "NO_SEARCH_RESULT": "Nessun risultato trovato",
    "SENTIMENT_AWAITING": "In attesa di sentimento",
    "POSITIVE": "Positivo",
    "NEGATIVE": "Negativo",
    "COPY": "Copia",
    "PLAYBOOK": "Playbook",
    "TELL_US_MORE": "Raccontaci di più…",
    "TAB_TEXT":"Nessuna scheda abilitata! Abilita almeno una scheda",
    "THANKS_FEEDBACK": "Grazie per il tuo feedback",
    "SOMETHING_WRONG": "Qualcosa è andato storto",
    "CLICK_ERROR_DETAILS": "Clicca per vedere i dettagli dell'errore",
    "NO_ACTIVE_PLAYBOOK": "Nessun playbook attivo",
    "REPHRASE_QUESTION": "Puoi riformulare la tua domanda o chiedere qualcos'altro?",
    "INTERNAL_INFO": "Informazioni interne",
    "SOURCES": "Fonti",
    "CONVERSATION_SUMMARY": "Riepilogo della conversazione",
    "WAITING": "In attesa",
    "WIDGET_DISABLED": "Widget disabilitato",
    "AI_SETTINGS_DISABLED": "Le impostazioni AI sono disabilitate! Contatta l'amministratore AI",
    "SERVER_CONNECTION_ERROR": "Errore durante la connessione al server",
    "VIEW": "Visualizza",
    "ATTACHMENT_INPUT": "Input allegato",
    "TYPE_SUMMARY": "Scrivi un riepilogo",
    "VIEW_FULL_ARTICLE_2": "Visualizza l'articolo completo",
    "VIEW_FULL_FILE_2": "Visualizza il file completo",
    "BY":"Di",
    GENERATE_SUMMARY: "Genera riassunto",
    PREV_SUMMARIES: "Riepiloghi generati in precedenza",
    DIALOG_WORKFLOWS: "Flussi di lavoro di dialogo",
    SHOW_ALL_DIALOG: "Mostra tutte le attività di dialogo",
    SHOW_ALL_DIALOGS: "Mostra tutti i dialoghi",
    CUSTOM_TAB: "Scheda personalizzata",
    AGENT_INPUT: "Input dell'agente",
    "CUSTOM_EMPTY_MSG" : "Nessun flusso di lavoro attivo",
    "CUSTOM_TAB_DESC" : "Per avviare un flusso di lavoro, esegui uno dalla lista presente in basso sulla schermata.",
    "SUBMIT_OVERALL_FEEDBACK" : "Invia feedback generale",
    "FEEDBACK_POPUP_SUBTITLE" : "Feedback sul widget e sui suoi funzionalità",
    "FEEDBACK_SATISFIED" : "Soddisfatto",
    "FEEDBACK_UNSATISFIED" : "Non soddisfatto",
    "FEEDBACK_PROVIDE_REASONS" : "Fornisci ulteriori informazioni…",
    "FEEDBACK_TITLE" : "Feedback",
    "AGENTIC_THINKING" : "Pensando",
    "AGENTIC_AGENT_TITLE" : "Agente",
    "AGENTIC_COPILOT_MODE_TITLE" : "Modalità Copilota Agente",
    "AGENTIC_SENDING_MESSAGE" : "Invio in corso...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot sta ascoltando attivamente la tua conversazione ed è pronto ad assistere automaticamente",
    "AGENTIC_SEARCH_RESULTS" : "Risultati Agenti"
}
